import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CookieConsent = () => {
  const [show, setShow] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if user is logged in
    checkAuth();
    
    // Check if consent has already been given
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Show banner after 1 second
      setTimeout(() => setShow(true), 1000);
    }
  }, []);

  const checkAuth = async () => {
    try {
      await axios.get(`${API}/auth/me`, { withCredentials: true });
      setIsLoggedIn(true);
    } catch (error) {
      setIsLoggedIn(false);
    }
  };

  const updateConsentBackend = async (granted) => {
    if (!isLoggedIn) return;
    
    try {
      await axios.post(`${API}/gdpr/update-consent`, {
        consent_type: 'analytics',
        granted: granted,
        consent_text: 'User consent for analytics cookies and tracking'
      }, { withCredentials: true });
    } catch (error) {
      console.error('Failed to update consent:', error);
    }
  };

  const handleAcceptAll = async () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      essential: true,
      analytics: true,
      timestamp: new Date().toISOString()
    }));
    
    await updateConsentBackend(true);
    setShow(false);
  };

  const handleRejectNonEssential = async () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      essential: true,
      analytics: false,
      timestamp: new Date().toISOString()
    }));
    
    await updateConsentBackend(false);
    setShow(false);
  };

  const handleCustomize = () => {
    window.location.href = '/gdpr-settings';
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t-2 border-gray-200 shadow-2xl animate-slide-up">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-start gap-4">
          <Cookie className="w-8 h-8 text-blue-600 flex-shrink-0 mt-1" />
          
          <div className="flex-1">
            <h3 className="text-lg font-semibold mb-2">We Value Your Privacy</h3>
            <p className="text-sm text-gray-600 mb-4">
              We use essential cookies to provide our services and plan to use analytics cookies to improve your experience. 
              By clicking "Accept All", you consent to our use of cookies in accordance with our{' '}
              <a href="/cookie-policy" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
                Cookie Policy
              </a>
              {' '}and{' '}
              <a href="/privacy-policy" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>.
            </p>
            
            <div className="flex flex-wrap gap-3">
              <Button 
                onClick={handleAcceptAll}
                className="bg-blue-600 hover:bg-blue-700"
              >
                Accept All
              </Button>
              <Button 
                onClick={handleRejectNonEssential}
                variant="outline"
              >
                Reject Non-Essential
              </Button>
              <Button 
                onClick={handleCustomize}
                variant="ghost"
              >
                Customize
              </Button>
            </div>
          </div>
          
          <button
            onClick={() => setShow(false)}
            className="text-gray-400 hover:text-gray-600 flex-shrink-0"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;